/**
 * Cortita y al pie — Sincronizador de carrito (camiseta + dorsal + parche)
 *
 * El dorsal y los parches se cobran con productos "recargo" ocultos (líneas
 * aparte en el carrito). Este script los mantiene LIGADOS a su camiseta:
 *
 *  - Cada camiseta personalizada lleva una propiedad oculta `_grupo`; sus
 *    recargos llevan la misma. Así sabemos qué recargos pertenecen a qué camiseta.
 *  - Si se quita la camiseta  -> se quitan sus recargos.
 *  - Si se quita un recargo   -> se borra esa personalización de la camiseta
 *                                (Nombre/Número o Parche), para que el pedido
 *                                nunca incluya algo que no se ha pagado.
 *  - Si cambia la cantidad de la camiseta -> la de sus recargos se iguala.
 *
 * Se ejecuta al cargar cualquier página, tras cada cambio del carrito y justo
 * antes de ir al pago. Es idempotente: si todo está en orden, no hace nada.
 */
(function () {
  var DORSAL_VARIANT_ID = 57397200945478;
  var RECARGO_TYPE = 'Recargo-personalizacion';
  var running = null;

  // Las líneas de recargo (dorsal / parche) no se pueden quitar ni cambiar de cantidad
  // por separado: van ligadas a su camiseta.
  (function injectStyles() {
    var parche = '.cart-item:has(a.cart-item__name[href*="/products/parche-"])';
    var dorsal = '.cart-item:has(a.cart-item__name[href*="/products/personalizacion-dorsal"])';
    var css =
      parche + ' .cart-item__quantity-wrapper,' +
      dorsal + ' .cart-item__quantity-wrapper{display:none!important}' +
      parche + ' .cart-item__name,' +
      dorsal + ' .cart-item__name{font-size:1.3rem;font-weight:400}';
    var style = document.createElement('style');
    style.setAttribute('data-cortita-cart-sync', '');
    style.textContent = css;
    document.head.appendChild(style);
  })();

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function isRecargo(item) {
    return item.product_type === RECARGO_TYPE;
  }
  function groupOf(item) {
    return item.properties && item.properties._grupo ? String(item.properties._grupo) : '';
  }
  function hasDorsalProps(item) {
    var p = item.properties || {};
    return !!(p['Nombre'] || p['Número']);
  }
  function hasPatchProp(item) {
    return !!(item.properties && item.properties['Parche']);
  }
  function sumQty(items) {
    return items.reduce(function (n, i) {
      return n + i.quantity;
    }, 0);
  }

  // Calcula qué hay que corregir.
  // Devuelve { qty: {key: nuevaCantidad}, clears: [{key, variantId, quantity, props}] }
  function plan(cart) {
    var groups = {};
    cart.items.forEach(function (item) {
      var g = groupOf(item);
      if (!g) return;
      var G = groups[g] || (groups[g] = { jerseys: [], dorsal: [], patches: [] });
      if (isRecargo(item)) {
        (item.variant_id === DORSAL_VARIANT_ID ? G.dorsal : G.patches).push(item);
      } else {
        G.jerseys.push(item);
      }
    });

    var qty = {};
    var clearKeys = {}; // jersey.key -> {propName: true}

    function markClear(jersey, names) {
      var c = clearKeys[jersey.key] || (clearKeys[jersey.key] = { item: jersey, names: {} });
      names.forEach(function (n) {
        c.names[n] = true;
      });
    }

    // Una "cara" de la personalización: dorsal (Nombre/Número) o parche (Parche)
    function syncSide(lines, jerseysWithProp, propNames) {
      var need = sumQty(jerseysWithProp);
      var have = sumQty(lines);
      if (need > 0 && have === 0) {
        // Hay personalización escrita en la camiseta pero su recargo ya no está
        // (el cliente lo quitó, o falló al añadirse): se borra la personalización.
        jerseysWithProp.forEach(function (j) {
          markClear(j, propNames);
        });
      } else if (need === 0 && have > 0) {
        lines.forEach(function (l) {
          qty[l.key] = 0;
        });
      } else if (need > 0 && have > 0 && have !== need) {
        lines.forEach(function (l, idx) {
          qty[l.key] = idx === 0 ? need : 0;
        });
      }
    }

    Object.keys(groups).forEach(function (g) {
      var G = groups[g];
      if (!G.jerseys.length) {
        // Camiseta eliminada: fuera sus recargos.
        G.dorsal.concat(G.patches).forEach(function (l) {
          qty[l.key] = 0;
        });
        return;
      }
      syncSide(G.dorsal, G.jerseys.filter(hasDorsalProps), ['Nombre', 'Número']);
      syncSide(G.patches, G.jerseys.filter(hasPatchProp), ['Parche']);
    });

    // Camisetas con _grupo pero sin ninguna personalización restante: limpiar _grupo
    // (así se vuelven a comportar/fusionar como una camiseta normal).
    var clears = [];
    cart.items.forEach(function (item) {
      if (isRecargo(item) || !groupOf(item)) return;
      var c = clearKeys[item.key];
      var names = c ? c.names : {};
      var dorsalLeft = hasDorsalProps(item) && !(names['Nombre'] || names['Número']);
      var patchLeft = hasPatchProp(item) && !names['Parche'];
      var needsGroupClear = !dorsalLeft && !patchLeft;
      if (!c && !needsGroupClear) return;

      // Propiedades que se quedan (sin las borradas y sin vacías)
      var props = {};
      Object.keys(item.properties || {}).forEach(function (k) {
        var v = item.properties[k];
        if (names[k] || v === '' || v == null) return;
        props[k] = v;
      });
      if (needsGroupClear) delete props._grupo;
      clears.push({ key: item.key, variantId: item.variant_id, quantity: item.quantity, props: props });
    });

    return { qty: qty, clears: clears };
  }

  // Freno de seguridad: nunca más de 2 recargas seguidas en 20 s (evita bucles).
  function reloadAllowed() {
    try {
      var now = Date.now();
      var times = JSON.parse(sessionStorage.getItem('cortitaSyncReloads') || '[]').filter(function (t) {
        return now - t < 20000;
      });
      if (times.length >= 2) return false;
      times.push(now);
      sessionStorage.setItem('cortitaSyncReloads', JSON.stringify(times));
    } catch (e) {}
    return true;
  }

  function refreshUI() {
    // En la página del carrito lo más fiable es recargar.
    if (document.getElementById('main-cart-items')) {
      if (reloadAllowed()) window.location.reload();
      return;
    }
    // Mini-carrito: pedimos las secciones actualizadas y las repintamos.
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var drawerHtml = sections['cart-drawer'];
        if (drawerHtml) {
          var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          var cartDrawer = document.querySelector('cart-drawer');
          var newDrawer = doc.querySelector('cart-drawer');
          var newInner = doc.querySelector('.drawer__inner');
          var oldInner = document.querySelector('cart-drawer .drawer__inner');
          if (cartDrawer && newInner && oldInner) {
            oldInner.innerHTML = newInner.innerHTML;
            // Carrito vacío: Dawn marca <cart-drawer class="... is-empty">
            var empty = newDrawer
              ? newDrawer.classList.contains('is-empty')
              : !!doc.querySelector('cart-drawer-items.is-empty');
            oldInner.classList.toggle('is-empty', empty);
            cartDrawer.classList.toggle('is-empty', empty);
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {});
  }

  function doReconcile() {
    // Mientras la página de producto está añadiendo camiseta + recargos, esperamos.
    if (window.cortitaAddonsBusy) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(doReconcile());
        }, 700);
      });
    }
    return getCart().then(function (cart) {
      var p = plan(cart);
      var qtyKeys = Object.keys(p.qty);
      if (!qtyKeys.length && !p.clears.length) return false;

      var chain = Promise.resolve();
      if (qtyKeys.length) {
        chain = chain.then(function () {
          return post('/cart/update.js', { updates: p.qty });
        });
      }
      // Quitar personalización de una camiseta: se vuelve a añadir limpia y se borra la línea
      // vieja (así no quedan propiedades vacías en el pedido).
      p.clears.forEach(function (c) {
        chain = chain.then(function () {
          return post('/cart/add.js', {
            items: [{ id: c.variantId, quantity: c.quantity, properties: c.props }],
          }).then(function (r) {
            if (r && r.status) throw new Error('No se pudo limpiar la personalización');
            var added = r && r.items && r.items[0];
            if (added && added.key === c.key) return; // se fusionó con la misma línea: no borrar
            var u = {};
            u[c.key] = 0;
            return post('/cart/update.js', { updates: u });
          });
        });
      });
      return chain.then(function () {
        refreshUI();
        return true;
      });
    });
  }

  function reconcile() {
    if (running) return running;
    running = doReconcile()
      .catch(function (e) {
        console.error('Cortita: error al sincronizar el carrito', e);
        return false;
      })
      .then(function (changed) {
        running = null;
        return changed;
      });
    return running;
  }

  window.cortitaCartSync = reconcile;

  function init() {
    // 1) Al cargar la página (cualquiera), cuando el navegador esté libre.
    if (window.requestIdleCallback) window.requestIdleCallback(reconcile, { timeout: 2500 });
    else setTimeout(reconcile, 800);

    // 2) Tras cada cambio del carrito hecho por el cliente (quitar, cantidad...).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event) return;
        if (event.source === 'product-form' || event.source === 'cortita-sync') return;
        reconcile();
      });
    }

    // 3) Justo antes de ir al pago: comprobar que todo está ligado y en orden.
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout');
        if (!btn) return;
        if (btn.dataset.cortitaChecked === '1') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        reconcile().then(function (changed) {
          if (changed) return; // se ha corregido el carrito: el cliente debe revisarlo
          btn.dataset.cortitaChecked = '1';
          btn.click();
          setTimeout(function () {
            delete btn.dataset.cortitaChecked;
          }, 3000);
        });
      },
      true
    );
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
